import { Citizenship } from "../models/citizenship";

import BaseService from "./_base.service";

const endpoint = "citizenships";

const CitizenshipService = {
  ...BaseService<Citizenship>({ endpoint }),
};

export default CitizenshipService;
